import { IModel } from "maps-angular-components";

export interface AtivoDTO {
  id: string;
  nome: string;
}

export class Autocomplete implements IModel {

  id: string;
  nome: string;

  constructor(obj: AtivoDTO)
  {
    this.id = obj.id;
    this.nome = obj.nome;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.nome;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }

}
